'use strict';

var errorText = [
	'Invalid format for the selected country',
	'Invalid country code for the selected country.',
	'The phone number is too short.',
	'The phone number is too long.',
	'The phone number is local-only.',
	'Invalid length.'
];
module.exports = function module_validate_phonenumber(selector, errorContainerSelector, errorClass, requiredClass) {
	errorContainerSelector = errorContainerSelector || '.errorContainer';
	errorClass = errorClass || 'error';
	requiredClass = requiredClass || 'isRequired';

	var error = false;
	if (!document.querySelector(selector)) {
		return false;
	}
	if (!window.intlTelInputGlobals) {
		return false;
	}
	const iti = window.intlTelInputGlobals.getInstance(document.querySelector(selector));
	window.jQuery(selector).each(function forEachField() {
		var $this = window.jQuery(this);
		//you can't require an invisible text field
		if ($this.is(':visible')) {
			//only validate if there is a value prevents a sudo "required"  However if .reguired
			if ($this.val() !== '' || $this.hasClass(requiredClass)) {
				if (!iti.isValidNumber()) {
					var errorContainer = $this.closest(errorContainerSelector);
					errorContainer.addClass(errorClass);
					errorContainer
						.children('.errorIcon')
						.html('<i class="fa fa-warning"></i> ' + errorText[iti.getValidationError()]);
					error = true;
				} else {
					$this.closest(errorContainerSelector).removeClass(errorClass);
				}
			} else {
				//reset if the field failed validation then was reset to empty, and is not required
				$this.closest(errorContainerSelector).removeClass(errorClass);
			}
		}
	});
	return error;
};
